











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleAIFeaturesMutation_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useAI",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ToggleAIFeaturesSuccess",
  "abstractKey": null
};

(node ).hash = "66faec3dd651fe03992f8bf090592606";

export default node;
